import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types/AppState";
import { acceptAlert, discardAlert } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      alert: localState.alert
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(discardAlert(props)),
  onConfirm: () => dispatch(acceptAlert(props))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
